module.exports = __webpack_public_path__ + "static/media/10_Wittig_webfinal.0d7e80ed.jpg";